import { JsonPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-data',
  imports: [JsonPipe],
  templateUrl: './view-data.component.html',
  styleUrl: './view-data.component.css'
})
export class ViewDataComponent {

  @Input() titulo: string = '';
  @Input() texto: string = '';
  @Input() data: unknown = null;
  constructor(
    private readonly _activeModal: NgbActiveModal
  ) {}

  salir(estado: boolean): void {
    this._activeModal.close(estado);
  }

}
